/* eslint-disable */ import { assertNumber, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kickPlateFixingHolesComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'horizontalCount', true).withAlias('KickPlateFixingHoles').attach(memoEval((self)=>[
            self.horizontalCount,
            self.$availableHorizontalHoleCountOptions
        ], (horizontalCount, $availableHorizontalHoleCountOptions)=>({
            value: horizontalCount,
            options: $availableHorizontalHoleCountOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalCount: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'verticalCount', true).withAlias('KickPlateFixingHoles').attach(memoEval((self)=>[
            self.verticalCount,
            self.$availableVerticalHoleCountOptions
        ], (verticalCount, $availableVerticalHoleCountOptions)=>({
            value: verticalCount,
            options: $availableVerticalHoleCountOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalCount: state.value
        };
    })
];

//# sourceMappingURL=kick-plate-fixing-holes.js.map